

  (function($) {
  	
	$(document).ready(function() {		
		wolfpoint.init();
		
	});
	

	var wolfpoint = {
        wolfpointTimeout: null,
		isSidebarAjaxClick: false,
		init: function() {			
			this.window_resize();
			this.header();
			this.slider();
			this.grid_height();			
			this.review();
// 			this.drag();
			this.blog_tabs();
			this.type_style();
            this.carousel_slider();
            this.package();
            this.magento_tabs();
       },
		
     	window_resize: function(){
			$(window).load(function(){
				wolfpoint.resizeContent(); 
				wolfpoint.scroll_Fixed();
				wolfpoint.about_scroll();
				$(window).resize(function() {
					wolfpoint.resizeContent();
				    wolfpoint.scroll_Fixed();
					wolfpoint.about_scroll();
				});
			});

		},
      
      package : function(){
      
      $('.home_package_section .budget_form_new').submit(function(event){
       event.preventDefault(); 
      	var bauget = $('.est_budget').val();
       
        var bauget_new = parseInt(bauget);
        if(bauget_new < 5001){
          $('.home_package_section .packages_item').removeClass('active');
        	$('.home_package_section .first_price').addClass('active');
            $('.home_package_section .packages_list').addClass('homepackage');
        }
        else if(5001 < bauget_new && bauget_new < 10001){
          $('.home_package_section .packages_item').removeClass('active');
        	$('.home_package_section .second_price').addClass('active');
            $('.home_package_section .packages_list').addClass('homepackage');
        }
        else if(10001 < bauget_new && bauget_new < 15001){
          $('.home_package_section .packages_item').removeClass('active');
        	$('.home_package_section .third_price').addClass('active');
            $('.home_package_section .packages_list').addClass('homepackage');
        }
        else{
          $('.home_package_section .packages_item').removeClass('active');
        	$('.home_package_section .custom').addClass('active');
             $('.home_package_section .packages_list').addClass('homepackage');
        }
      });   
        
     },
		
		resizeContent: function(){	
			header_height = $('#header').height();	
			features_banner = $(window).height() - header_height;
//			$('.features-banner, #page_banner, #connect_banner').css('height' , features_banner);
			site_height = $('#site_design .up_down').height() - 303;
          	site_height_2 = $('.euphebe_design .up_down').height() - 200;
            var result = parseFloat(parseInt(site_height_2, 10) * 36) / 100 ;
          	
			part_height	= site_height/3;		
			$('#site_design .up_down .modify_part').css('height' , part_height);
          	seconDpart = site_height_2 - (result * 2);
            $('.euphebe_design .up_down .modify_part:nth-child(1)').css('height' , result + 50);	
            $('.euphebe_design .up_down .modify_part:nth-child(3)').css('height' , result + 50);
          	$('.euphebe_design .up_down .modify_part:nth-child(2)').css('height' , seconDpart);
			var slider_height = $('.mobile_design').outerHeight();
			$('.slider_design').css('height' , slider_height);
			var site_height = $('.site_designed').outerHeight();
			var customer_height = $('.customer_review').outerHeight();
			var store_height = $('.store_img img').outerHeight() - 180;
			$('.site_slider').css('height' , site_height);
			$('.store_admin').css('height' , store_height);
			$('.customer_slider').css('height' , customer_height);
          
            if($(window).width()< 1025){
                  var notification_h = $('.notifications_bar').outerHeight();
                  $('#PageContainer').css('padding-top' , notification_h);
              }
             $(".notification-close").on("click",function(){
                  $(".notifications_bar").slideUp();
                  $("#PageContainer").css("padding-top","0");
               	  $("#PageContainer").addClass('rmv_pad');
                  $(".notifications_bar").addClass('rmv_height');
            });
		},
		
		
		//================ RESPONSIVE MENU TRIGGER 		
		
		
		header: function(){
			
			/*======   mean menu  =======*/
			
			jQuery('header nav').meanmenu();
			
			/*======   fixed header  =======*/
			
			var lastScrollTop = 0;
			
			$(window).scroll(function(event){
			   var st = $(this).scrollTop();
			   if (st > lastScrollTop){
				   // downscroll code
				   if($(window).width()< 1025)
				   $('#header').attr('class','mean-container nav-up');
				   else
				   $('#header').attr('class','nav-up');
			   } else {
				  // upscroll code
				  if(st == 0){
					  
						if($(window).width()< 1025)
						$('#header').attr('class','mean-container');
						else
						$('#header').attr('class','');
				 }
				  else{
					  
					if($(window).width()< 1025)
					$('#header').attr('class','mean-container nav-down');
					else
					$('#header').attr('class','nav-down');
				  }
			   }
			   lastScrollTop = st;
			});
			
			
			$('.meanmenu-reveal').each(function(index, element) {
                $(this).click(function(e) {
					$('body').toggleClass('overflow');
				});
			});
			
		},	
		
		type_style: function(){
			$(function(){

				$("#typed").typed({
					stringsElement: $('#typed-strings'),
					typeSpeed: 100,
					backDelay: 1500,
					loop: false,
					contentType: 'html', 
					loopCount: false,
					callback: function(){ foo(); },
					resetCallback: function() { newTyped(); }
				});
		
				$(".reset").click(function(){
					$("#typed").typed('reset');
				});
		
			});
		
			function newTyped(){ }
			function foo(){ console.log("Callback"); }
		},
		
	    //================  SLIDER
		
		
		slider: function(){
			$('.bxslider').bxSlider({
			  mode: 'fade',
			  captions: true
			});
			$('.large_img').bxSlider({
			  pagerCustom: '#bx-pager',
			  captions: false,
			  controls:false,
			});
		},
			
        //============================== PRODUCT LIST IMG HEIGHT        	
		
		grid_height: function(){	             
          $('.packages_list .packages_item .package_Body').responsiveEqualHeightGrid();
		  // $('.review_item .review_content').responsiveEqualHeightGrid();
		},	
		
		
		carousel_slider: function(){
            if ($(window).width() < 768){          
              $('#about_slider').owlCarousel({
                loop:false,
                nav:false,
                autoHeight:true,
                dots:true,
                responsive:{
                  0:{
                    items:1
                  },
                  767:{
                    items:1
                  },
                }
              });
            }
			
			if ($(window).width() < 1025){
				$('#review .review_list').owlCarousel({
						loop:true,
						nav:true,
						margin:-1,
                        autoHeight:true,
						responsive:{
							0:{
								items:1
							},
							480:{
								items:2
							},
							600:{
								items:3
							},							
                          	840:{
								items:3,
							},
                            992:{
								items:4,
							},
						}
				});
			}
					
				
			$('#blog .blog_list').owlCarousel({
				loop:true,
				nav:true,
				margin:30,
				responsive:{
					0:{
						items:1
					},
					480:{
						items:1
					},
					500:{
						items:2
					},
					768:{
						items:2,
						margin:10
					},
					1024:{
						items:2,
						margin:10
					},
					1201:{
						items:2,
						dots:false
					}
				}
			});	
			
			
			$('.related_blog .blog_list').owlCarousel({
				loop:true,
				nav:false,
				controls:false,
				margin:30,
				responsive:{
					0:{
						items:1
					},
					480:{
						items:1
					},
					500:{
						items:2
					},
					768:{
						items:2,
						margin:10
					},
					1024:{
						items:2,
						margin:10
					},
					1201:{
						items:2,
						dots:false
					}
				}
			});	
			

			$('.mobile_design ul').owlCarousel({
				stagePadding: 140,
				loop:true,
				margin:45,
				nav:true,
				dots: false,
				responsive:{
					0:{
						items:2,
						stagePadding:40,
						margin:25
					},
					481:{
						items:3,
						stagePadding:80,
						margin:25
					},
					768:{
						items:2,
						stagePadding: 56,
						margin:35
					},
					992:{
						items:2,
						stagePadding: 68,
						margin:45
					},
					1025:{
						items: 3
					},
					1921:{
						items: 4
					}
				}
				
			});	
			$('.site_designed ul').owlCarousel({
				stagePadding: 125,
				loop:true,
				nav:false,
				dots: false,
				responsive:{
					0:{
						items:2,
						stagePadding:40,
					},
					481:{
						items:3,
						stagePadding:80,
					},
					768:{
						items:2,
						stagePadding: 56,
					},
					992:{
						items:2,
						stagePadding: 68,
					},
					1025:{
						items: 4,
						stagePadding: 0,
					},
					1200:{
						items: 3,
					},
					1921:{
						items: 4
					}
				}
				
			});	
			
			$('.customer_review ul').owlCarousel({
				stagePadding:0,
				loop:true,
				margin:70,
				nav:false,
				dots: false,
				responsive:{
					0:{
						items:1,
						stagePadding:10,
						margin:20
					},
					481:{
						items:2,
						stagePadding:40,
						margin:25
					},
					768:{
						items:1,
						stagePadding:190,
						margin:25
					},
					992:{
						items:2,
						stagePadding: 60,
						margin:40
					},
					1025:{
						items: 3
					},
					1921:{
						items: 4
					}
				}
				
			});	
			
			$('ul.brand_list').owlCarousel({
				loop:true,
				nav:false,
				controls:false,
				responsive:{
					0:{
						items:2
					},
					480:{
						items:3
					},
					500:{
						items:4
					},
					768:{
						items:5,
						margin:10
					},
					992:{
						items:6,
						margin:10
					},
					1025:{
						items:6,
						dots:false,
						loop:false
					}
				}
			});					
		},	
		
		review: function(){
			$('.review_list .review_item').each(function(index, element) {
                $(this).click(function(e) {
                    $(this).siblings().removeClass('active');
					$(this).addClass('active');
                });
            });
			
			$('.home_package_section .packages_list .packages_item').each(function(index, element) {
                $(this).click(function(e) {
                    $(this).siblings().removeClass('active');
					$(this).addClass('active');
                });
            });
		},
		
		drag: function(){
          $('.after_design, .before_design').imagedrag({
            input: "#output",
            position: "top",
            attribute: "html"
          });
		},
		
		blog_tabs: function(){
		   $( "#blog_tabs" ).tabs({
			  collapsible: true
			});
		},
		
	    scroll_Fixed: function(){
			if ($(window).width() > 767){
				 var summaries = $('.share_post');
				 summaries.each(function(i) {
					var summary = $(summaries[i]);
					var next = summaries[i + 1];
				
					summary.scrollToFixed({
						marginTop: $('#header').outerHeight(true) + 10,
						limit: function() {
							var limit = 0;
							if (next) {
								limit = $(next).offset().top - $(this).outerHeight(true) - 10;
							} else {
								limit = $('.blog_tag').offset().top - $(this).outerHeight(true) - 10;
							}
							return limit;
						},
						zIndex: 999
					});
				});
			}
			
			if ($(window).width() > 1024){
				 var summaries = $('.posts-pagination');
				 summaries.each(function(i) {
					var summary = $(summaries[i]);
					var next = summaries[i + 1];
				
					summary.scrollToFixed({
						marginTop: $('#artical').outerHeight(true) + 10,
						limit: function() {
							var limit = 0;
							if (next) {
								limit = $(next).offset().top - $(this).outerHeight(true) - 10;
							} else {
								limit = $('#footer').offset().top - $(this).outerHeight(true) - 10;
							}
							return limit;
						},
						zIndex: 999
					});
				});
			}
		},
      
      magento_tabs: function(){
          $( "#compare_tabs" ).tabs({
            collapsible: true
          });

          $('#what_saying .review_list').owlCarousel({
            loop:true,
            nav:true,
           // margin:22,
			autoHeight: true,
            responsive:{
              0:{
                items:1
              },
              767:{
                items:1,
              },
            }
          });
	  },
      
      about_scroll: function(){
        
          $("#scroll_down").click(function() {
             if ($(window).width() > 767){  
                $('html, body').animate({
                  scrollTop: $("#about_section").offset().top
                }, 1000);
            }
            if ($(window).width() < 768){  
              $('html, body').animate({
                scrollTop: $("#about_slider").offset().top
              }, 1000);
            }
          });  
        
          if ($(window).width() > 767){              

              $.scrollify({
                section:".panel",
                sectionName:false,
                interstitialSection : ".demo,.footer-cta",
                setHeights : false,
                after:function(i) {

                },
                before:function(i) {

                  if(i==4){ 
                    $('#about_content').fadeIn();
                  }

                  if(i==5){
                    $('#about_content').fadeOut('fast');
                  }	

                  var active = $(".slide-text.active, .slide-img.active");	
                  active.addClass("remove");
                  $("[data-slide=" + i + "]").addClass("active");
                  active.removeClass("remove active");
                },
                afterRender:function()  {
                  $(".panel").each(function() {
                    $(this).css("height", parseInt($(window).height()));	
                    $(this).find(".inner").css("height", $(window).height());	
                  });	
                  $.scrollify.update();	
                  $("[data-slide=0]").addClass("active");	
                }	
              });	
          }
      },
	
     }
			
})(jQuery);	